<template>
  <div id="app" :app-version="appVersion" @click="closeEvents">
    <vue-snotify></vue-snotify>
    <v-error-modal name="error-modal"></v-error-modal>
    <v2-media-library-selector
      :showLibrary="showMediaLibrary"
      :data="currentMediaLibraryData"
    ></v2-media-library-selector>
    <div
      class="extra-wrapper"
      v-if="
        teams[$route.params.team] &&
        teams[$route.params.team].account !== null &&
        teams[$route.params.team].authenticated &&
        teams[$route.params.team].account.team.subscription !== null
      "
    >
      <v-spinner :loading="isLoading || isCustomLoading" class="content-spinner"></v-spinner>
      <v2-sidebar-mobile
        @beforeTeamSelectOpen="sessionClosedLogout"
        :links="sidebarMobileLinks"
        :teams="authenticatedTeams"
        :currentTeam="currentTeam"
        :signOutFromTeam="
          (obj) => {
            logout({
              logoutAllTeams: obj.logoutAllTeams,
              logoutThisTeam: obj.logoutThisTeam,
            });
          }
        "
      >
      </v2-sidebar-mobile>
      <v2-sidebar
        @beforeTeamSelectOpen="sessionClosedLogout"
        :minimized="this.teamsSettings[this.$route.params.team].sidebarIsMinimized"
        @sidebarIsMinimized="toggleMinimzedState"
        :links="sidebarLinks"
        :currentTeam="currentTeam"
        :teams="authenticatedTeams"
        :signOutFromTeam="
          (obj) => {
            logout({
              logoutAllTeams: obj.logoutAllTeams,
              logoutThisTeam: obj.logoutThisTeam,
            });
          }
        "
      ></v2-sidebar>
      <main
        :class="{
          'sidebar-minimized': this.teamsSettings[this.$route.params.team].sidebarIsMinimized,
        }"
      >
        <router-view :key="$route.fullPath" />
      </main>
    </div>
    <div
      class="extra-wrapper"
      v-if="
        !teams[$route.params.team] ||
        (teams[$route.params.team] && !teams[$route.params.team].authenticated) ||
        (teams[$route.params.team] &&
          teams[$route.params.team].authenticated &&
          teams[$route.params.team].account.team.subscription === null)
      "
    >
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import pusher from "@/assets/js/pusher.js";
import MediaLibrarySelector from "./views/partials/MediaLibrarySelector";

export default {
  name: "App",
  components: {
    "v2-media-library-selector": MediaLibrarySelector,
  },
  data() {
    return {
      showHints: false,
      activityRefresher: null,
      showMediaLibrary: false,
      currentMediaLibraryData: {},
    };
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.$eventbus.$on("initActivityRefresher", this.initActivityRefresher);
    this.$eventbus.$on("changeTeam", this.changeTeam);
    this.$eventbus.$on("getMessagesCounter", this.getMessagesCounter);
    this.$eventbus.$on("openMediaLibrary", this.openMediaLibrary);
    this.$eventbus.$on("closeMediaLibrary", this.closeMediaLibrary);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    this.$eventbus.$off("initActivityRefresher");
    this.$eventbus.$off("changeTeam");
    this.$eventbus.$off("getMessagesCounter");
    this.$eventbus.$off("openMediaLibrary");
    this.$eventbus.$off("closeMediaLibrary");
    if (this.activityRefresher) {
      clearInterval(this.activityRefresher);
    }
  },
  mounted() {},
  methods: {
    ...mapActions([
      "getProjectsActivityFeeds",
      "logout",
      "toggleShowTips",
      "setMessagesCounter",
      "getNotifications",
      "sessionClosedLogout",
    ]),
    openMediaLibrary(data) {
      this.currentMediaLibraryData = data;
      this.showMediaLibrary = true;
    },
    closeMediaLibrary() {
      this.showMediaLibrary = false;
    },
    toggleMinimzedState(isMinimized) {
      this.$store.commit("GLOBALE_SIDEBAR_SET_MINIMZED_STATE", isMinimized);
    },
    closeEvents() {
      this.$eventbus.$emit("closeAllDropdowns");
      // this.$eventbus.$emit("closeSearch");
    },
    changeTeam(data) {
      this.$router
        .push({ name: "Dashboard", params: { team: data.uid } })
        .then(() => {
          data.cb();
        })
        .catch(() => {});
      // this.refreshData(uid);
    },
    initActivityRefresher(team) {
      if (team && this.activityRefresher === null) {
        this.activityRefresher = setInterval(() => {
          this.getProjectsActivityFeeds({
            type: "Dropdown",
            customLoading: true,
          });
        }, 15000);
      } else {
        if (this.activityRefresher) {
          clearInterval(this.activityRefresher);
        }
      }
    },
    getMessagesCounter(team) {
      const vm = this;
      const params = {
        team,
        type: "project_message",
        unread: true,
      };
      vm.getNotifications({
        customLoading: true,
        params,
      }).then((res) => {
        vm.setMessagesCounter(res.data.meta.pagination.total);
      });
    },
    handleResize() {
      this.$windowWidth = window.innerWidth;
    },
  },
  computed: {
    currentRoute: function () {
      return this.$route;
    },
    currentTeam: function () {
      return this.teams[this.$route.params.team];
    },
    authenticatedTeams: function () {
      const authTeamsArray = [];
      const currentTeam = this.$route.params.team;
      if (currentTeam && this.teams[currentTeam] && this.teams[currentTeam].account) {
        Object.keys(this.teams).forEach((key) => {
          if (
            this.teams[key].authenticated &&
            this.teams[key].cognito.username === this.teams[currentTeam].cognito.username
          ) {
            authTeamsArray.push({
              name: this.teams[key].team.name,
              uid: this.teams[key].team.uid,
              redirect: () => {
                this.changeTeam({ uid: key });
              },
            });
          }
        });
      }
      return authTeamsArray;
    },
    sidebarLinks: function () {
      return [
        {
          name: this.$t("sidebar.dashboard"),
          route: "Dashboard",
          isActive: this.$route.name === "Dashboard",
          icon: require("@icon/Icon=pie-chart.svg"),
        },
        {
          name: this.$t("sidebar.quickLaunch"),
          route: "QuickLaunch",
          isActive: this.$route.name === "QuickLaunch",
          icon: require("@icon/Icon=rocket.svg"),
          iconClass: "icon-rocket",
          iconOriginal: true,
          iconFill: true,
        },
        {
          name: this.$t("sidebar.clients"),
          route: "Clients",
          isActive: this.$route.name === "Clients",
          icon: require("@icon/Icon=users.svg"),
        },
        {
          name: this.$t("sidebar.projects"),
          route: "Projects",
          isActive: this.$route.name === "Projects",
          icon: require("@icon/Icon=folder.svg"),
        },
        {
          name: this.$t("sidebar.library"),
          route: "Library",
          isActive: this.$route.name === "Library",
          icon: require("@icon/Icon=file.svg"),
        },
        {
          name: this.$t("sidebar.inbox"),
          route: "Inbox",
          isActive: this.$route.name === "Inbox",
          icon: require("@icon/Icon=inbox.svg"),
          counter: this.teamsSettings[this.$route.params.team].messagesCounter,
        },
        {
          name: this.$t("sidebar.activityFeeds"),
          route: "ActivityFeeds",
          params: { tab: "all" },
          isActive: this.$route.name === "ActivityFeeds",
          icon: require("@icon/Icon=bell.svg"),
        },
        {
          name: this.showTips ? this.$t("sidebar.hideHints") : this.$t("sidebar.showHints"),
          method: () => {
            this.toggleShowTips(!this.showTips);
          },
          btnIsActive: this.showTips,
          position: "bottom",
          icon: require("@icon/Icon=bulb.svg"),
          iconColor: this.showTips ? "#FF7C1F" : "#fff",
        },
        {
          name: this.$t("sidebar.settings"),
          route: "Settings",
          params: { tab: "account" },
          isActive: this.$route.name === "Settings",
          icon: require("@icon/Icon=settings.svg"),
          position: "bottom",
        },
        {
          name: this.$t("sidebar.help"),
          link: this.$t("urls.support"),
          target: "envivo_support",
          icon: require("@icon/Icon=i.svg"),
          position: "bottom",
          iconFill: true,
        },
        {
          name: this.$t("teamRegistration.actions.terms"),
          link: this.$t("urls.terms"),
          target: "_blank",
          icon: require("@icon/Icon=i.svg"),
          position: "bottom",
          iconFill: true,
        },
        {
          name: this.$t("teamRegistration.actions.siteNotice"),
          link: this.$t("urls.siteNotice"),
          target: "_blank",
          icon: require("@icon/Icon=i.svg"),
          position: "bottom",
          iconFill: true,
        },
      ];
    },
    sidebarMobileLinks: function () {
      return [
        {
          name: this.$t("sidebar.dashboard"),
          route: "Dashboard",
          isActive: this.$route.name === "Dashboard",
          icon: require("@icon/Icon=pie-chart.svg"),
        },
        {
          name: this.$t("sidebar.quickLaunch"),
          route: "QuickLaunch",
          isActive: this.$route.name === "QuickLaunch",
          icon: require("@icon/Icon=rocket.svg"),
          iconClass: "icon-rocket",
          iconOriginal: true,
          iconFill: true,
        },
        {
          name: this.$t("sidebar.clients"),
          route: "Clients",
          isActive: this.$route.name === "Clients",
          icon: require("@icon/Icon=users.svg"),
        },
        {
          name: this.$t("sidebar.projects"),
          route: "Projects",
          isActive: this.$route.name === "Projects",
          icon: require("@icon/Icon=folder.svg"),
        },
        {
          name: this.$t("sidebar.library"),
          route: "Library",
          isActive: this.$route.name === "Library",
          icon: require("@icon/Icon=file.svg"),
        },
        {
          name: this.$t("sidebar.inbox"),
          route: "Inbox",
          isActive: this.$route.name === "Inbox",
          icon: require("@icon/Icon=inbox.svg"),
          counter: this.teamsSettings[this.$route.params.team].messagesCounter,
        },
        {
          name: this.$t("sidebar.activityFeeds"),
          route: "ActivityFeeds",
          params: { tab: "all" },
          isActive: this.$route.name === "ActivityFeeds",
          icon: require("@icon/Icon=bell.svg"),
        },
        {
          name: this.showTips ? this.$t("sidebar.hideHints") : this.$t("sidebar.showHints"),
          method: () => {
            this.toggleShowTips(!this.showTips);
          },
          btnIsActive: this.showTips,
          position: "bottom",
          icon: require("@icon/Icon=bulb.svg"),
          iconFill: this.showTips,
          iconOriginal: this.showTips,
          iconClass: this.showTips ? "icon-bulb-active" : "icon-bulb",
          iconColor: this.showTips ? "#FF7C1F" : "#5D5D5D",
        },
        {
          name: this.$t("sidebar.help"),
          link: "https://support.envivo.io/",
          target: "envivo_support",
          icon: require("@icon/Icon=i.svg"),
          iconFill: true,
          iconStroke: "#5D5D5D",
          iconClass: "icon-help",
          position: "bottom",
        },
        {
          name: this.$t("sidebar.settings"),
          route: "Settings",
          params: { tab: "account" },
          isActive: this.$route.name === "Settings",
          icon: require("@icon/Icon=settings.svg"),
          position: "bottom",
        },
      ];
    },
    ...mapGetters({
      teams: "auth_get_teams",
      isLoading: "global_is_loading",
      isCustomLoading: "global_is_custom_loading",
      // searchObject: "global_get_search_object",
      appVersion: "global_get_version",
      activityFeedItemsForDropdown: "projects_get_activity_feed_items_for_dropdown",
      showTips: "global_get_show_tips",
      teamsSettings: "global_get_teams_settings",
    }),
  },
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          if (document.getElementById("sib-conversations")) {
            if (newVal.meta.hideSupportBtn) {
              document.getElementById("sib-conversations").style.visibility = "hidden";
            } else {
              document.getElementById("sib-conversations").style.visibility = "visible";
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.team": {
      handler: function (newVal, oldVal) {
        console.log("---------------------------", newVal, oldVal);
        if (newVal && newVal !== oldVal) {
          pusher.init(newVal);
          if (oldVal) {
            pusher.unsubscribe(oldVal);
          }
          pusher.subscribe(newVal, this.$snotify);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang=""></style>
